import api from "@/lib/api";
import { toast } from "sonner";

export async function startCheckout({ kind, resource_id, tip_tier }) {
  try {
    const { data } = await api.post("/payments/checkout", {
      kind,
      resource_id,
      tip_tier,
      origin_url: window.location.origin,
    });
    if (data.checkout_url) {
      window.location.href = data.checkout_url;
    }
  } catch (e) {
    toast.error(e.response?.data?.detail || "Could not start checkout");
  }
}
